import { createSelector } from "reselect";

import { MainNavigationStore } from "../stores/types";

export const selectNavigationIsExpanded = createSelector(
  (state: MainNavigationStore) => state.isSidebarExpanded,
  (state: MainNavigationStore) => state.mobileFullScreen,
  (isSidebarExpanded, mobileFullScreen): boolean => isSidebarExpanded || mobileFullScreen
);

export const selectNavigationShowsExpandedContent = createSelector(
  (state: MainNavigationStore) => state.isSidebarExpanded,
  (state: MainNavigationStore) => state.mobileFullScreen,
  (state: MainNavigationStore) => state.isSidebarInPreview,
  (isSidebarExpanded, mobileFullScreen, isSidebarInPreview): boolean =>
    isSidebarExpanded || mobileFullScreen || isSidebarInPreview
);
